import { throwRepoErrorFromApiV3Error } from '@webapp/core/utils/repositories/throwRepoErrorFromApiV3Error'
import { type IHttpClient } from '@webapp/infrastructure/interfaces/services/IHttpClient'
import { type IGlobalSearchRepository } from '../../business-logic/interfaces/IGlobalSearchRepository'
import { type GlobalSearchResultConstructor } from '../../value-objects/GlobalSearchResult'
import { mapGlobalSearchResultsApiModel } from '../mappers/mapGlobalSearchResultsApiModel'
import { type GlobalSearchPayload } from '../types/GlobalSearchPayload'
import { type GlobalSearchResponse } from '../types/GlobalSearchResponse'

interface Dependency {
  httpClient: IHttpClient
}

export class GlobalSearchRepository implements IGlobalSearchRepository {
  constructor(private readonly deps: Dependency) {}

  async search(
    payload: GlobalSearchPayload
  ): Promise<GlobalSearchResultConstructor> {
    try {
      const response = await this.deps.httpClient.post<GlobalSearchResponse>(
        '/api/v3/global-command/search/',
        payload
      )

      return mapGlobalSearchResultsApiModel(response.data)
    } catch (error) {
      throw throwRepoErrorFromApiV3Error(error)
    }
  }
}
